var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXMessageBubbleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.27,10.14C24.42,10.14,3.46,27.65,3.46,49.25c0,9.1,3.73,17.47,9.96,24.11-.78,6.61-9.96,19.28-9.96,19.28,0,0,11.49,2.38,30.2-6.82h0c5.16,1.64,10.76,2.54,16.61,2.54,25.85,0,46.81-17.51,46.81-39.12S76.12,10.14,50.27,10.14Zm14.37,47.54c1.56,1.56,1.56,4.09,0,5.66-.78,.78-1.8,1.17-2.83,1.17s-2.05-.39-2.83-1.17l-7.77-7.77-7.77,7.77c-.78,.78-1.8,1.17-2.83,1.17s-2.05-.39-2.83-1.17c-1.56-1.56-1.56-4.09,0-5.66l7.77-7.77-7.77-7.77c-1.56-1.56-1.56-4.09,0-5.66s4.1-1.56,5.66,0l7.77,7.77,7.77-7.77c1.56-1.56,4.1-1.56,5.66,0,1.56,1.56,1.56,4.09,0,5.66l-7.77,7.77,7.77,7.77Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXMessageBubbleIcon);
export default __webpack_public_path__ + "static/media/x-message-bubble-icon.2e21ca3edc954d3ee1b19a1dece044fa.svg";
export { ForwardRef as ReactComponent };